import { OutgoingPostbackTrigger, PayoutResultAll, PayoutType } from "types/enums.ts";
import { z } from "zod";

export const schema = z.object({
    name: z.string().min(1, "forms.general-validation.name_required"),
    is_active: z.boolean(),
    first_sequence_step_id: z.string().nullable(),

    types: z.array(z.string()).optional(),
    sources: z.array(z.string()).optional(),
    offer_ids: z.array(z.string()).optional(),
    excluded_offer_ids: z.array(z.any()).optional(),
    country_id: z.number().nullable().optional(),
    affiliate_ids: z.array(z.string()).optional(),
    advertiser_ids: z.array(z.string()).optional(),
    integration_ids: z.array(z.string()).optional(),
    cascade_ids: z.array(z.string()).optional(),
    trigger: z.nativeEnum(OutgoingPostbackTrigger),
    payout_result: z.nativeEnum(PayoutResultAll).nullable().optional(),
    payout_type: z.nativeEnum(PayoutType).nullable().optional(),
    owner_id: z.string().optional(),
    form_structure_ids: z.array(z.string()).optional(),
});

export type AddTrackingToolToFormData = z.infer<typeof schema>;
